var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "client"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('b-card', {
    attrs: {
      "size": "modal-lg"
    },
    on: {
      "ok": function($event) {
        _vm.addHandovermodal = false
      }
    }
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.is_Loading
    }
  }), _vm._v(" "), _c('form', {
    attrs: {
      "id": "frm",
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_vm._v(" " + _vm._s(_vm.$t('manifesthandover.manifesttitle')) + " ")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.salesChannel')) + ":"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.saleschannel),
      expression: "saleschannel"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control ",
    class: {
      'form-control': true,
      'error': _vm.errors.has('SalesChannel')
    },
    attrs: {
      "name": "SalesChannel",
      "id": "SalesChannel",
      "disabled": !_vm.ifmanifestID
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.saleschannel = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getcourierlist]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.salesChannelPlaceholder')) + " ")]), _vm._v(" "), _vm._l((_vm.channellist), function(channel) {
    return _c('option', {
      domProps: {
        "value": channel.channel_name
      }
    }, [_vm._v("\n                    " + _vm._s(channel.channel_name))])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('SalesChannel')),
      expression: "errors.has('SalesChannel')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('clientChannelMaster.salesChannelError')) + "  ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.courierCompany')) + " :"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('v-select', {
    class: {
      'error': _vm.errors.has('CourierCompany')
    },
    attrs: {
      "options": _vm.listCourierData,
      "label": "couriername",
      "reduce": function (warehouse_obj) { return warehouse_obj.couriername; },
      "clearable": false,
      "disabled": !_vm.ifmanifestID,
      "placeholder": _vm.$t('common.courierCompanyPlaceHolder')
    },
    on: {
      "input": function (val) {
        _vm.CourierCompany = (val && typeof val === 'object') ? val.couriername : val;
        _vm.onchangecourier();
      }
    },
    model: {
      value: (_vm.CourierCompany),
      callback: function($$v) {
        _vm.CourierCompany = $$v
      },
      expression: "CourierCompany"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('CourierCompany')),
      expression: "errors.has('CourierCompany')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('common.courierCompanyError')) + "  ")])], 1)]), _vm._v(" "), (_vm.agrregatorlist.length > 0) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('manifesthandover.aggregatorName')) + ":"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])]), _vm._v(" "), (_vm.agrregatorlist.length > 0) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.aggregator),
      expression: "aggregator"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('CourierCompany')
    },
    attrs: {
      "name": "aggregator",
      "disabled": !_vm.ifmanifestID,
      "id": "aggregator"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.aggregator = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {}]
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('manifesthandover.noAggregator')) + " ")]), _vm._v(" "), _vm._l((_vm.agrregatorlist), function(courier_obj) {
    return _c('option', {
      domProps: {
        "value": courier_obj
      }
    }, [_vm._v(_vm._s(courier_obj))])
  })], 2)]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('manifesthandover.sellername')) + " :"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellername),
      expression: "sellername"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control ",
    class: {
      'form-control': true,
      'error': _vm.errors.has('SellerName')
    },
    attrs: {
      "name": "SellerName",
      "id": "SellerName",
      "disabled": !_vm.ifmanifestID
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.sellername = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.onchange]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('manifesthandover.selectsellername')))]), _vm._v(" "), _vm._l((_vm.listSellerData), function(channel) {
    return _c('option', {
      domProps: {
        "value": channel.sellername
      }
    }, [_vm._v("\n                    " + _vm._s(channel.sellername) + " ")])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('SellerName')),
      expression: "errors.has('SellerName')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('manifesthandover.sellerNameError')) + "  ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v(" " + _vm._s(_vm.$t('orders.b2BOrder')) + " :")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block !important"
    }
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.b2border),
      expression: "b2border"
    }],
    ref: "rolesSelected",
    staticStyle: {
      "display": "inline-block",
      "height": "16px",
      "width": "16px"
    },
    attrs: {
      "disabled": !_vm.ifmanifestID,
      "type": "checkbox",
      "id": "b2border",
      "name": "b2border"
    },
    domProps: {
      "checked": Array.isArray(_vm.b2border) ? _vm._i(_vm.b2border, null) > -1 : (_vm.b2border)
    },
    on: {
      "change": function($event) {
        _vm.abc($event)
      },
      "__c": function($event) {
        var $$a = _vm.b2border,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.b2border = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.b2border = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.b2border = $$c
        }
      }
    }
  })])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }), _vm._v(" "), (_vm.manifestid) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('manifesthandover.manifestid')) + " :")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_vm._v("\n                " + _vm._s(this.manifestid) + "\n              ")])]) : _vm._e(), _vm._v(" "), (_vm.manifestid) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.awbNo')) + " :")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.awbno),
      expression: "awbno"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (''),
      expression: "''"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('awbno')
    },
    attrs: {
      "type": "text",
      "disabled": !_vm.isClosed && _vm.manifestid && _vm.displayawnno,
      "placeholder": _vm.$t('supportRequest.aWBNumberPlaceHolder'),
      "name": "awbno",
      "id": "awbno"
    },
    domProps: {
      "value": (_vm.awbno)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.checkinput($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.awbno = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('awbno')),
      expression: "errors.has('awbno')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('awbno')) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 mrg"
  }, [_c('div', {
    staticClass: "row "
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": !_vm.isAWBScan,
      "size": "sm",
      "isLoading": _vm.isLoading
    },
    on: {
      "click": _vm.checkinput
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('boxList.scan')))]), _vm._v("   \n\n                    "), _c('button', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "margin-left": "1%"
    },
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.resetaddDeatilsForm
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(_vm._s(_vm.$t('common.resetBtn')))]), _vm._v("  \n                  ")])])])]) : _vm._e(), _vm._v(" "), (_vm.displayawnno == true) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v(" " + _vm._s(_vm.$t('manifesthandover.ScanedAWBno')) + " :")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "overflow": "auto",
      "margin-top": "18px"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('manifesthandover.SearchAWBno')) + " :")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "overflow": "auto"
    }
  }, [(_vm.manifestid) ? _c('b-form-fieldset', [_c('label', {
    staticStyle: {
      "font-size": "1em",
      "margin-top": "-24px",
      "margin-left": "-35px",
      "margin-bottom": "-4px"
    }
  }, [_c('div', {
    staticClass: "form__group field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.awbnoForSearch),
      expression: "awbnoForSearch"
    }],
    staticClass: "form__field",
    staticStyle: {
      "font-size": "1em",
      "margin-top": "-24px",
      "margin-left": "22px",
      "margin-bottom": "-4px"
    },
    attrs: {
      "disabled": !_vm.isClosed && _vm.manifestid && _vm.displayawnno,
      "type": "input",
      "placeholder": _vm.$t('manifesthandover.ScanedAWBno'),
      "name": "name",
      "id": "name",
      "required": ""
    },
    domProps: {
      "value": (_vm.awbnoForSearch)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.awbnoForSearch = $event.target.value
      }, _vm.SearchAwb]
    }
  })])]), _vm._v("    \n                ")]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.b2border && _vm.manifestid) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('manifesthandover.NumberOfBoxes')) + ": ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.noofboxes),
      expression: "noofboxes"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('noofboxes')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('manifesthandover.NumberOfBoxes'),
      "name": "noofboxes",
      "id": "noofboxes"
    },
    domProps: {
      "value": (_vm.noofboxes)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.checkinput($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.noofboxes = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 mrg"
  }, [_c('div', {
    staticClass: "row "
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.checkinput
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('manifesthandover.addtoManifestbtn')) + "                    ")]), _vm._v("   \n                  ")])])])]) : _vm._e(), _vm._v(" "), (_vm.displayawnno == true) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('manifesthandover.readyToHandover')) + " :")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "overflow": "auto"
    }
  }, [(_vm.manifestid) ? _c('b-form-fieldset', [(_vm.showsearchAwbNO == false) ? _c('div', {
    staticStyle: {
      "height": "100px",
      "border-style": "ridge",
      "overflow-y": "auto"
    }
  }, _vm._l((_vm.listTotalmanifestIDData.awb_details), function(select) {
    return _c('label', {
      key: select.awb_no,
      staticClass: "pref-button checkbox",
      staticStyle: {
        "padding-left": "10pt",
        "padding-right": "10pt",
        "padding-top": "5pt",
        "width": "39%"
      },
      attrs: {
        "for": select.id
      }
    }, [_c('label', {
      staticStyle: {
        "font-size": "1em"
      }
    }, [_vm._v(_vm._s(select.awb_no) + " "), _c('i', {
      staticClass: "fa fa-times",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.remove(select)
        }
      }
    })])])
  })) : _vm._e(), _vm._v(" "), (_vm.showsearchAwbNO == true) ? _c('div', {
    staticStyle: {
      "height": "100px",
      "border-style": "ridge",
      "overflow-y": "auto"
    }
  }, _vm._l((_vm.arrayofsearchAWBNO), function(select) {
    return _c('label', {
      key: select.awb_no,
      staticClass: "pref-button checkbox",
      staticStyle: {
        "padding-left": "10pt",
        "padding-right": "10pt",
        "padding-top": "5pt",
        "width": "39%"
      },
      attrs: {
        "for": select.id
      }
    }, [_c('label', {
      staticStyle: {
        "font-size": "1em"
      }
    }, [_vm._v(_vm._s(select) + " "), _c('i', {
      staticClass: "fa fa-times",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.remove(select)
        }
      }
    })])])
  })) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('manifesthandover.totalAwb')) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_vm._v("\n                  " + _vm._s(_vm.noofAwbs) + "\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.displayawnno == true && _vm.listTotalmanifestIDData.awb_details_cancel.length > 0) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('manifesthandover.cancelOrderAWB')) + ":")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "overflow": "auto"
    }
  }, [(_vm.manifestid) ? _c('b-form-fieldset', [_c('div', {
    staticStyle: {
      "height": "100px",
      "border-style": "ridge",
      "overflow-y": "auto"
    }
  }, _vm._l((_vm.listTotalmanifestIDData.awb_details_cancel), function(select) {
    return _c('label', {
      key: select.awb_no,
      staticClass: "pref-button checkbox",
      staticStyle: {
        "padding-left": "10pt",
        "padding-right": "10pt",
        "padding-top": "5pt",
        "width": "39%"
      },
      attrs: {
        "for": select.id
      }
    }, [_c('label', {
      staticStyle: {
        "font-size": "1em"
      }
    }, [_vm._v(_vm._s(select.awb_no) + " ")])])
  }))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-2",
    staticStyle: {
      "overflow": "auto"
    }
  }, [(_vm.manifestid) ? _c('b-form-fieldset', [_c('label', {
    staticStyle: {
      "font-size": "1em",
      "margin-top": "-24px",
      "margin-left": "-35px",
      "margin-bottom": "-4px"
    }
  }, [_c('div', {
    staticClass: "form__group field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.awbnoForSearchCancel),
      expression: "awbnoForSearchCancel"
    }],
    staticClass: "form__field",
    staticStyle: {
      "font-size": "1em",
      "margin-top": "-24px",
      "margin-left": "22px",
      "margin-bottom": "-4px"
    },
    attrs: {
      "disabled": !_vm.isClosed && _vm.manifestid && _vm.displayawnno,
      "type": "input",
      "placeholder": _vm.$t('manifesthandover.ScanedAWBno'),
      "name": "name",
      "id": "name",
      "required": ""
    },
    domProps: {
      "value": (_vm.awbnoForSearchCancel)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.removeCancelAWB($event)
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.awbnoForSearchCancel = $event.target.value
      }, _vm.SearchAwb]
    }
  })])]), _vm._v("    \n                ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 mrg"
  }, [_c('div', {
    staticClass: "row "
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.awbnoForSearchCancel == '',
      "size": "sm"
    },
    on: {
      "click": _vm.removeCancelAWB
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('manifesthandover.removeAWBBtn')))]), _vm._v("   \n                  ")])])])]) : _vm._e(), _vm._v(" "), _c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "inwardfooter form-actions float-right"
  }, [(_vm.displayawnno == true && _vm.manifest_status == 'close') ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "variant": "primary",
      "disabled": !_vm.isComplete1 || !_vm.isCancelExist
    },
    on: {
      "click": _vm.printManifestAction
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" " + _vm._s(_vm.$t('manifesthandover.printManifest')))]) : _vm._e(), _vm._v("  \n              "), (_vm.displayawnno == true && _vm.manifest_status == 'close') ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "variant": "primary",
      "disabled": !_vm.isComplete1 || !_vm.isCancelExist
    },
    on: {
      "click": _vm.handoverAction
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('handover.handover')))]) : _vm._e(), _vm._v("  \n              "), (_vm.displayawnno == true && _vm.manifest_status == 'open') ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": !_vm.isClosed || !_vm.isCancelExist,
      "size": "sm"
    },
    on: {
      "click": _vm.CloseManifestAction
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('manifesthandover.closingManifest')))]) : _vm._e(), _vm._v("  \n              "), (_vm.displayawnno == true) ? _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.resetaddDeatilsForm
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(_vm._s(_vm.$t('common.resetBtn')))]) : _vm._e(), _vm._v("  \n\n            ")]), _vm._v(" "), (_vm.manifestid == '') ? _c('div', {
    staticClass: "inwardfooter form-actions float-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "variant": "primary",
      "disabled": !_vm.isComplete1
    },
    on: {
      "click": _vm.newmanifest
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('manifesthandover.newManifestBtn')) + "\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.openManifest
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('manifesthandover.openmanifestbtn')) + "\n              ")]), _vm._v("  \n            ")]) : _vm._e()], 1)])], 1)], 1), _vm._v(" "), _c('b-modal', {
    staticClass: "confirmation",
    attrs: {
      "size": "lm",
      "no-close-on-backdrop": true,
      "no-fade": true,
      "id": "handovermodelid",
      "title": _vm.$t('orders.pickerTransfer')
    },
    model: {
      value: (_vm.pickerTransferShow),
      callback: function($$v) {
        _vm.pickerTransferShow = $$v
      },
      expression: "pickerTransferShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('handover.handover')) + "  ")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeHandoverModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [(_vm.HideDetails) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('manifesthandover.closeManifest')) + "?\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('button', {
    staticClass: "btn btn-danger glasssec  float-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.pickerTransferShow = false;
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('common.no')) + "\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary glass float-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.showDeatils
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('common.yes')) + "\n                ")])])]) : _vm._e(), _vm._v(" "), (_vm.ShowDeatils) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('merchant.personName')) + "\n                ")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.HandoverPersonName),
      expression: "HandoverPersonName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('HandoverPersonName')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('handover.handoverpersonPlaceholder'),
      "name": "HandoverPersonName",
      "disabled": _vm.isdisableValue,
      "id": "HandoverPersonName"
    },
    domProps: {
      "value": (_vm.HandoverPersonName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.HandoverPersonName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('HandoverPersonName')),
      expression: "errors.has('HandoverPersonName')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('HandoverPersonName')) + "\n                ")])])]) : _vm._e(), _vm._v(" "), (_vm.ShowDeatils) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('inwardList.inward.vehicleNo')) + "\n                ")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.VehicleNO),
      expression: "VehicleNO"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('VehicleNO')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('inwardList.inward.vehicleNoPlaceholder'),
      "name": "VehicleNO",
      "disabled": _vm.isdisableValue,
      "id": "VehicleNO"
    },
    domProps: {
      "value": (_vm.VehicleNO)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.VehicleNO = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('VehicleNO')),
      expression: "errors.has('VehicleNO')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('VehicleNO')) + "\n                ")])])]) : _vm._e(), _vm._v(" "), (_vm.ShowDeatils && !_vm.ShowSpoc) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Image Count")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._v("\n                " + _vm._s(_vm.uploadedImagesCount) + "\n              ")])]) : _vm._e(), _vm._v(" "), (_vm.ShowDeatils && !_vm.ShowSpoc) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.productImage')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [(!_vm.selectfileFlag) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.chooseUpload()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-upload"
  }), _vm._v(" " + _vm._s(_vm.$t('product.upload')))]) : _vm._e(), _vm._v(" "), (_vm.selectfileFlag) ? _c('i', {
    staticClass: "fa fa-camera fa-lg mt-2 ml-3",
    staticStyle: {
      "cursor": "pointer",
      "color": "#ff0000"
    },
    attrs: {
      "title": _vm.$t('rtogrnb2b.uploadProduct')
    },
    on: {
      "click": function($event) {
        _vm.uploadManifestImage('camera')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.selectfileFlag) ? _c('i', {
    staticClass: "fa fa-file fa-lg mt-2 ml-3",
    staticStyle: {
      "cursor": "pointer",
      "color": "#ff0000"
    },
    attrs: {
      "title": _vm.$t('editedjson.selectProductLabel')
    },
    on: {
      "click": function($event) {
        _vm.uploadManifestImage('file')
      }
    }
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.ShowDeatils && !_vm.ShowSpoc) ? _c('div', {
    staticClass: "form-group row col-md-10"
  }, [(!_vm.cameraSection && _vm.fileSection) ? _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-around"
    }
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    ref: "file",
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "type": "file",
      "id": "file",
      "name": "file"
    },
    on: {
      "change": function($event) {
        _vm.handleFileUpload()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.saveImage('file')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-upload"
  }), _vm._v(" " + _vm._s(_vm.$t('product.upload')))])])]) : _vm._e(), _vm._v(" "), (_vm.cameraSection && !_vm.fileSection) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('cameraApp.selectCamera')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cameralist),
      expression: "cameralist"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "cameralist"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.cameralist = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.cameraSelected]
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "hidden": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('cameraApp.selectCamera')))]), _vm._v(" "), _vm._l((_vm.cameras), function(client_obj) {
    return _c('option', {
      domProps: {
        "value": client_obj.deviceId
      }
    }, [_vm._v(" " + _vm._s(client_obj.label))])
  })], 2)]), _vm._v(" "), _c('web-cam', {
    ref: "cameraImage",
    attrs: {
      "autoplay": "autoplay",
      "playsinline": _vm.playsinline,
      "height": 500,
      "width": 455,
      "screenshotFormat": _vm.screenshotFormat,
      "selectFirstDevice": _vm.selectFirstDevice
    },
    on: {
      "cameras": _vm.camerass
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.captureImage()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-camera"
  }), _vm._v(" " + _vm._s(_vm.$t('cameraApp.capture')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.resetImage()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" " + _vm._s(_vm.$t('cameraApp.retake')))])]), _vm._v(" "), (this.imageCaptured) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.saveImage('camera')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-upload"
  }), _vm._v(" " + _vm._s(_vm.$t('product.upload')))])]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.ShowDeatils && _vm.ShowSpoc) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Seal ID\n                ")]), (_vm.validateSeal) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sealID),
      expression: "sealID"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (_vm.validateSeal ? 'required' : ''),
      expression: "validateSeal ? 'required' : ''"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('sealID')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Seal ID",
      "name": "sealID",
      "disabled": _vm.isdisableValue,
      "id": "sealID"
    },
    domProps: {
      "value": (_vm.sealID)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sealID = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('sealID')),
      expression: "errors.has('sealID')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('sealID')) + "\n                ")])])]) : _vm._e()]), _vm._v(" "), (_vm.ShowDeatils) ? _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "btn btn-primary glass float-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.saveHandover()
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('common.ok')) + "\n            ")])]) : _vm._e()])])]), _vm._v(" "), _c('b-modal', {
    staticClass: "confirmation",
    attrs: {
      "size": "lm",
      "title": _vm.$t('orders.pickerTransfer')
    },
    model: {
      value: (_vm.ClosedmanifestShow),
      callback: function($$v) {
        _vm.ClosedmanifestShow = $$v
      },
      expression: "ClosedmanifestShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('handover.handover')) + " ")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.ClosedmanifestShow = false;
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('manifesthandover.closingManifesthandover')) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('button', {
    staticClass: "btn btn-danger glasssec  float-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.ClosedmanifestShow = false;
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('common.no')) + "\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary glass float-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.CloseManifest
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('common.yes')) + "\n                ")])])])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg"
    },
    model: {
      value: (_vm.printManifestModal),
      callback: function($$v) {
        _vm.printManifestModal = $$v
      },
      expression: "printManifestModal"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "col-12 printBody",
    attrs: {
      "id": "printPoContent"
    }
  }, [_c('div', {
    staticStyle: {
      "overflow-x": "hidden"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    slot: "header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closePrintModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "page-header"
  }, [_c('table', {
    staticClass: "table table-bordered ",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "font-weight": "bold",
      "padding-left": "5px",
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.$t('manifesthandover.manifestid')))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v(" " + _vm._s(_vm.manifestid))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-weight": "bold",
      "padding-left": "5px",
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.$t('manifesthandover.manifestDate')))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v(" " + _vm._s(_vm.manifest_date) + " ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-weight": "bold",
      "padding-left": "5px",
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.client')))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v(" " + _vm._s(_vm.wmsclientname) + " ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-weight": "bold",
      "padding-left": "5px",
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.warehouse')))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v(" " + _vm._s(_vm.wmswarehousename) + " ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-weight": "bold",
      "padding-left": "5px",
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.salesChannel')))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v(" " + _vm._s(_vm.saleschannel) + " ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-weight": "bold",
      "padding-left": "5px",
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.courier')))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v(" " + _vm._s(_vm.CourierCompany) + " ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-weight": "bold",
      "padding-left": "5px",
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.$t('manifesthandover.totalAwb')))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(" " + _vm._s(_vm.noofAwbs) + " ")])])])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('td', [_c('div', {
    staticClass: "page-header-space"
  })])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('div', {
    staticClass: "page"
  }, [_c('table', {
    attrs: {
      "width": "100%"
    }
  }, [_c('thead', [_c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('orders.srNo')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('ShippingDetails.awbNo')) + "#")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.orderID')))])]), _vm._v(" "), _c('tbody', _vm._l((_vm.awbList), function(data, index) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v(" " + _vm._s(index + 1) + " ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(data.awb_no) + " ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(data.order_no))])])
  }))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "page-footer"
  }, [_c('table', {
    staticClass: "table table-bordered ",
    staticStyle: {
      "width": "98%"
    }
  }, [_c('thead'), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "font-weight": "bold",
      "padding-left": "5px",
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.$t('orders.handoverDate')))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(" " + _vm._s(_vm.manifest_date) + " ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-weight": "bold",
      "padding-left": "5px",
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.$t('orders.handoverBy')))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-weight": "bold",
      "padding-left": "5px",
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.$t('orders.handoverTo')))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  })])])])])])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-bottom": "10px",
      "margin-right": "20px",
      "float": "right"
    },
    attrs: {
      "href": "javascript:void(0)"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.loading ? _vm.loadingText : _vm.$t('common.print'))
    },
    on: {
      "click": function($event) {
        _vm.print()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" " + _vm._s(_vm.$t('common.print')))])])])], 1)])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f374405e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f374405e","hasScoped":true}!./src/views/components/manifesthandover/manifesthandover.component.html
// module id = 1882
// module chunks = 0